jQuery( function( $ ) {	
	$( document ).ready( function() {    
        var shorLessLink = '<a class="read-more" href="#">' + app_localize.translations["mostrar_menos"] + '</a>';
        var shorMoreLink = '<a class="read-more" href="#">' + app_localize.translations["mostrar_mas"] + '</a>';
        $('.busqueda .texto').readmore({ speed: 75, collapsedHeight: 76, lessLink: shorLessLink, moreLink: shorMoreLink });
    });
}); 
